// extracted by mini-css-extract-plugin
export var modal = "_t7-0";
export var table = "_t7-1";